import { create } from "zustand";
import { collectionObj } from "../firebase/fireFuncs";
import { forArrayLength } from "../misc/helperfuncs";

const collectionStore = create((set) => ({
  history: { ...collectionObj.history },
  open: { ...collectionObj.open },
  saved: { ...collectionObj.saved },
  general: { ...collectionObj.general },
  setArray: (col, type, array) => {
    set((state) => {
      return { [col]: { ...state[col], [type]: array } };
    });
  },
  setGeneralObjects: (objects) => {
    if (objects)
      set((state) => {
        return { general: objects };
      });
  },
  updateArray: (col, type, newArray) => {
    set((state) => {
      return { [col]: { ...state[col], [type]: newArray } };
    });
  },
  addGeneralObjects: (objects, getPluralType) => {
    set((state) => {
      const newGeneral = { ...state.general };
      forArrayLength(Array.from(objects), (object) => {
        newGeneral[getPluralType(object.type)] = newGeneral[
          getPluralType(object.type)
        ].filter((o) => o.id != object.id);

        newGeneral[getPluralType(object.type)].push({
          ...object,
          added: Date.now(),
        });
      });

      localStorage.setItem("general", JSON.stringify(newGeneral));
      return { general: newGeneral };
    });
  },
}));

export default collectionStore;
